import React, { useState } from 'react';

import { infoTechApi as api } from 'api/infoTech';
import { FormComponent, Notifications } from 'shared';

function CreateKnowledgeBase() {
    const [notification, setNotification] = useState({ text: null, level: null });
    const formFields = [
        {
            name: 'title',
            inputElement: 'textField',
            label: 'Title',
            gridValue: 4,
            inputProps: { required: true },
        },
        {
            name: 'problem',
            inputElement: 'textField',
            label: 'Problem',
            gridValue: 8,
            inputProps: { required: true },
        },
        {
            name: 'investigation',
            inputElement: 'textEditor',
            label: 'Investigation',
            gridValue: 12,
            inputProps: { required: true },
        },
        {
            name: 'solution',
            inputElement: 'textEditor',
            label: 'Solution',
            gridValue: 12,
            inputProps: { required: true },
        },
    ];

    const createKnowledgeBaseEntry = async (formData) => {
        const response = await api.createKnowledgeBase(formData);
        if (response.status === true) {
            setNotification({ text: 'Knowledge base entry created!', level: 'success' });
            return true;
        }
        let message = 'Error creating knowledge base entry';
        if (response && response.msg) {
            message += `: ${response.msg}`;
        }
        setNotification({ text: message, level: 'error' });
        return false;
    };

    return (
        <div>
            <h1>Create Knowledge Base</h1>
            <Notifications options={notification} />
            <div style={{ outline: 0, backgroundColor: 'white' }}>
                <FormComponent
                    formFields={formFields}
                    onSubmit={async (formData, resetForm) => {
                        const success = await createKnowledgeBaseEntry(formData);
                        if (success) {
                            resetForm();
                        }
                    }}
                />
            </div>
        </div>
    );
}

export { CreateKnowledgeBase };
